"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPropertiesListToCommonSites = exports.returnLocationAttribute = exports.countryCodeToTranslatedName = exports.getCountryCodeBeforeDash = void 0;
const utils_1 = require("./utils");
const utils_2 = require("./utils/utils");
const getCountryCodeBeforeDash = (countryCode) => {
    if (countryCode.includes('-')) {
        return countryCode.split('-')[0];
    }
    return countryCode;
};
exports.getCountryCodeBeforeDash = getCountryCodeBeforeDash;
const countryCodeToTranslatedName = ({ countryCode, language, }) => {
    if (!countryCode || !language)
        return undefined;
    try {
        const processedCode = (0, exports.getCountryCodeBeforeDash)(countryCode).toUpperCase();
        const countryName = new Intl.DisplayNames([language], {
            type: 'region',
        });
        try {
            return countryName.of(processedCode);
        }
        catch (e) {
            if (e instanceof RangeError) {
                console.warn(`Invalid country code: ${processedCode}`);
                return undefined;
            }
            throw e;
        }
    }
    catch (error) {
        console.error('Error translating country code:', error);
        return undefined;
    }
};
exports.countryCodeToTranslatedName = countryCodeToTranslatedName;
const returnLocationAttribute = ({ region, language, }) => {
    const isV2Response = 'countryCode' in region;
    const isNovasol = !region.rhs3;
    if (isV2Response && region?.countryCode && isNovasol) {
        return (0, exports.countryCodeToTranslatedName)({
            countryCode: region.countryCode,
            language,
        });
    }
    return region.location;
};
exports.returnLocationAttribute = returnLocationAttribute;
const mapPropertiesListToCommonSites = (properties, summariesResult, language, elements) => {
    return properties.map((property) => {
        const isSingleCardinality = property.cardinality === 'SINGLE';
        const hasIncludedExtras = Boolean(property.includedExtras) || false;
        const populateReviewFromSummaries = !property.review;
        const averageReviewScore = populateReviewFromSummaries
            ? (0, utils_2.getSiteReviewDetails)(property.code, summariesResult)
                .averageReviewScore ?? 0
            : property.review?.averageScore ?? 0;
        const hasRequestedImages = elements.some((item) => item === 'IMAGES');
        const currentProperty = summariesResult.summaries.find((summaryObject) => summaryObject.code === property.code) ?? { displayName: '' };
        return {
            code: property.code,
            displayName: currentProperty.displayName,
            ...(property.capacity && {
                property: {
                    adults: property.capacity.adults,
                    children: property.capacity.children,
                    pets: property.capacity.pets,
                    sleeps: property.capacity.sleeps,
                    infants: property.capacity.infants,
                    ...(property.bedrooms && { bedrooms: property.bedrooms }),
                    ...(property.bathrooms && { bathrooms: property.bathrooms }),
                    ...(hasIncludedExtras && {
                        includedExtras: (0, utils_1.mapNovasolIncludedExtras)(property.includedExtras ?? [], language),
                    }),
                },
            }),
            grade: property.grade,
            offers: property.offers,
            ...(property.region?.location && {
                location: (0, exports.returnLocationAttribute)({
                    language,
                    region: property.region,
                }),
            }),
            ...(hasRequestedImages && {
                images: (0, utils_2.getPropertyImages)(property.code, summariesResult),
            }),
            ...(property.region?.rhs3 && { rhs3: property.region.rhs3 }),
            ...(property.price.type === 'FROM' && {
                priceFrom: property.price.price,
            }),
            lengthOfStay: property.price.lengthOfStay,
            ...(isSingleCardinality && { price: property.price.price }),
            ...(property.price?.wasPrice && { wasPrice: property.price.wasPrice }),
            isCustomerChoice: property.isCustomerChoice,
            petsGoFree: property.petsGoFree,
            ...(averageReviewScore > 0 && {
                averageReviewScore,
            }),
            ...(property.price?.startDate && { startDate: property.price.startDate }),
            USPs: (0, utils_2.getPropertyUsps)(property.code, summariesResult),
            features: [],
            cardinality: property.cardinality,
        };
    });
};
exports.mapPropertiesListToCommonSites = mapPropertiesListToCommonSites;
//# sourceMappingURL=mapPropertiesListToCommonSites.js.map